import React, {useState, useEffect} from 'react';
import {
    IconButton,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    Grid
} from '@material-ui/core';
import {Delete, Edit} from '@material-ui/icons';
import api from "../../api";
import {toast, ToastContainer} from "react-toastify";

function UsersList() {
    const [users, setUsers] = useState([]);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const [deleteUserId, setDeleteUserId] = useState(null);
    const [openEditDialog, setOpenEditDialog] = useState(false);
    const [editUserId, setEditUserId] = useState(null);
    const [editUserName, setEditUserName] = useState('');
    const [editUserUserName, setEditUserUserName] = useState('');
    const [editUserMobileNumber, setEditUserMobileNumber] = useState('');
    const [openCreateDialog, setOpenCreateDialog] = useState(false);
    const [newUserName, setNewUserName] = useState('');
    const [newUserUsername, setNewUserUsername] = useState('');
    const [newUserMobileNumber, setNewUserMobileNumber] = useState('');
    const [newUserPassword, setNewUserPassword] = useState('');
    const [newUserConfirmPassword, setNewUserConfirmPassword] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleEditOpen = (userId, userName, userUserName, userMobileNumber) => {
        setOpenEditDialog(true);
        setEditUserId(userId);
        setEditUserName(userName);
        setEditUserUserName(userUserName);
        setEditUserMobileNumber(userMobileNumber);
    };

    const handleEditClose = () => {
        setOpenEditDialog(false);
        setEditUserId(null);
        setEditUserName('');
        setEditUserUserName('');
        setEditUserMobileNumber('');
        window.location.reload();
    };

    const handleDeleteOpen = (userId) => {
        setOpenDeleteDialog(true);
        setDeleteUserId(userId);
    };

    const handleDeleteClose = () => {
        setOpenDeleteDialog(false);
        setDeleteUserId(null);
    };

    const handleEditSubmit = async () => {
        setIsLoading(true);
        try {
            const response = await api.post(`/user/${editUserId}`, {
                name: editUserName,
                username: p2e(editUserUserName),
                mobile_number: p2e(editUserMobileNumber),
            });
            setIsLoading(false)   // Hide loading screen

            handleEditClose();

        } catch (err) {
            toast.error(err.response.data.message)
        }
    };

    const handleDeleteSubmit = async () => {
        setIsLoading(true);
        try {
            await api.delete(`/user/${deleteUserId}`);
            setUsers(users.filter(user => user.id !== deleteUserId));
            handleDeleteClose();
            setIsLoading(false)   // Hide loading screen
        } catch (err) {
            toast.error(err.response.data.message)
        }
    };

    const handleCreateOpen = () => {
        setOpenCreateDialog(true);
    };

    const p2e = s => s.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d))

    const createUser = async (name, username, mobile_number, password) => {
        try {
            const response = await api.post('/user', {
                name: name,
                username: p2e(username),
                mobile_number: p2e(mobile_number),
                password: password,
            })
                .then((res) => {
                    setIsLoading(false)   // Hide loading screen
                    handleCreateClose()
                });
        } catch (err) {
            toast.error(err.response.data.message)
        }
    };

    const handleCreateClose = () => {
        setOpenCreateDialog(false);
        setNewUserName('');
        setNewUserUsername('');
        setNewUserMobileNumber('');
        setNewUserPassword('');
        setNewUserConfirmPassword('');
        // window.location.reload();
    };

    useEffect(() => {
        setIsLoading(true)
        const fetchUsers = async () => {
            try {
                const response = await api.get('/user');
                setUsers(response.data.data);
                setIsLoading(false)   // Hide loading screen
            } catch (error) {

            }
        };
        fetchUsers();
    }, []);

    return (
        <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
                <ToastContainer
                    position="top-center"
                    autoClose={1000}
                    hideProgressBar={false}
                    newestOnTop={false}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                    theme="light"
                />
                <div className="row justify-content-center">
                    <div className="col-12">
                        <div className="card border-3 rounded-4 border-dark mb-4">
                            <div className="card-header bg-dark text-center">
                                <button
                                    className='btn btn-lg btn-dark fw-bold fs-5'
                                    onClick={handleCreateOpen}
                                    disabled={true}
                                >
                                    لیست کاربران
                                </button>
                            </div>
                            <div className="card-body">
                                <div className='table-responsive'>
                                    <table className="table table-hover table-striped table-bordered table-rounded">
                                        <thead>
                                        <tr className="text-center shadow pb-4"
                                            style={{backgroundColor: 'var(--header-color)'}}>
                                            <th>شناسه</th>
                                            <th>نام و نام خانوادگی</th>
                                            <th>شماره ملی</th>
                                            <th>شماره موبایل</th>
                                            <th>ویرایش</th>
                                            <th>حذف</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        {users.map((user) => (
                                            <tr key={user.id}>
                                                <td className="text-center">
                                                    {user.id}
                                                </td>
                                                <td className="text-center">{user.name}</td>
                                                <td className="text-center">{user.username}</td>
                                                <td className="text-center">{user.mobile_number}</td>
                                                <td className="text-center">
                                                    <IconButton color="primary"
                                                                onClick={() => handleEditOpen(user.id, user.name, user.username, user.mobile_number)}>
                                                        <Edit/>
                                                    </IconButton>
                                                </td>
                                                <td className="text-center">
                                                    <IconButton color="secondary"
                                                                onClick={() => handleDeleteOpen(user.id)}>
                                                        <Delete/>
                                                    </IconButton>
                                                </td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <Dialog open={openDeleteDialog} onClose={handleDeleteClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">حذف کاربر</p>
                            </DialogTitle>
                            <DialogContent>
                                <DialogContentText>
                                    آیا مطمئن هستید که میخواهید کاربر را حذف کنید ؟
                                </DialogContentText>
                            </DialogContent>
                            <input className='btn btn-danger mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleDeleteSubmit}
                                   value="حذف"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleDeleteClose}
                                   value="انصراف"
                            />
                        </Dialog>
                        <Dialog open={openEditDialog} onClose={handleEditClose}>
                            <DialogTitle className="bg-dark">
                                <p className="text-white">ویرایش اطلاعات</p>
                            </DialogTitle>
                            <DialogContent>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        <label className='form-label'>نام و نام خانوادگی</label>
                                        <input
                                            id="name"
                                            type="text"
                                            value={editUserName}
                                            className='form-control shadow'
                                            onChange={(event) => setEditUserName(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <label className='form-label'>شماره ملی</label>
                                        <input
                                            id="username"
                                            type='text'
                                            maxLength={10}
                                            className='form-control shadow'
                                            value={editUserUserName}
                                            onChange={(event) => setEditUserUserName(event.target.value)}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <label className='form-label'>شماره موبایل</label>
                                        <input
                                            id="mobile_number"
                                            type='text'
                                            maxLength={11}
                                            className='form-control shadow'
                                            value={editUserMobileNumber}
                                            onChange={(event) => setEditUserMobileNumber(event.target.value)}
                                        />
                                    </Grid>
                                </Grid>
                            </DialogContent>
                            <input className='btn btn-warning mx-5 mb-2 mt-3' type="submit"
                                   onClick={handleEditSubmit}
                                   value="ذخیره"
                            />
                            <input className='btn btn-secondary mx-5 mb-2' type='button'
                                   onClick={handleEditClose}
                                   value="انصراف"
                            />
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default UsersList;
